<form [formGroup]="form" (ngSubmit)="submitForm()">
  <title mat-dialog-title>{{ 'common.phone' | t }}</title>

  <mat-dialog-content>
    <p>{{ 'account.dialogs.changePhone.description' | t }}</p>

    <sn-form [form]="form" [model]="formModel" [fields]="formFields"></sn-form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button mat-button type="submit" color="success" [mtBasicSpinner]="isLoading">{{ 'common.done' | t }}</button>
  </mat-dialog-actions>
</form>
